import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';
import { RootState } from '../../store/rootReducer';
import { checkOnbordingFlow } from '../login/utils';
import { InvestorStatus, UserStatus } from '../login/utils/Status';

type Props = {
    children: ReactNode;
};

const ScrollToTop: React.FC<Props> = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    //const isTeamMember = useIsTeamMember();

    const [currentPath, setCurrentPath] = useState(location.pathname);
    const [prevPath, setPrevPath] = useState<string | undefined>(undefined);

    const user = useSelector((state: RootState) => state.user);
    const userStatus = user.user?.status;
    const investorStatus = useSelector((state: RootState) => state.user.investor?.status);
    const isHIPLUser = useSelector((state: RootState) => state.user.investor?.isHIPL);
    const agreements = useSelector((state: RootState) => state.user.investor?.agreements);
    const HIPLAgreements = agreements?.find((a) => a.agreementType === 'HIPL AI Consent');
    const KYC = useSelector((state: RootState) => state.user.investor?.kyc?.reviewsV2);
    const KYC_Status = KYC?.find((k) => k.entity === 'HIPL')?.status;

    /**Get current Path */
    useEffect(() => {
        setCurrentPath(location.pathname);
    }, [location]);

    const url = checkOnbordingFlow(user);

    useEffect(() => {
        if (
            ((investorStatus?.profile === InvestorStatus.PendingPostAIAgreements &&
                investorStatus.accreditation === InvestorStatus.AIApproved) ||
                (investorStatus?.profile === InvestorStatus.Approved &&
                    isHIPLUser &&
                    !HIPLAgreements &&
                    KYC_Status === InvestorStatus.Approved)) &&
            !currentPath.includes(HEADERMENU_PATH.onboarding) &&
            currentPath !== HEADERMENU_PATH.accountActivationWithOtp &&
            currentPath !== HEADERMENU_PATH.resignAIConsent &&
            currentPath !== HEADERMENU_PATH.resignHIPLAIConsent &&
            currentPath !== HEADERMENU_PATH.resignNDA &&
            currentPath !== HEADERMENU_PATH.resignSubscription &&
            currentPath !== HEADERMENU_PATH.signAIConsent &&
            currentPath !== HEADERMENU_PATH.signHIPLAIConsent &&
            currentPath !== HEADERMENU_PATH.signSubscription &&
            currentPath !== HEADERMENU_PATH.postAgreements &&
            !url &&
            userStatus !== UserStatus.pendingActivation
            // &&
            // !isTeamMember
        ) {
            navigate(HEADERMENU_PATH.postAgreements);
        }
    }, [investorStatus, currentPath, url, userStatus, navigate, isHIPLUser, HIPLAgreements, KYC_Status]);

    useMemo(() => {
        if (prevPath !== currentPath) {
            window.scroll({
                top: 0,
                left: 0,
            });
            setPrevPath(currentPath);
        }
    }, [currentPath, prevPath]);

    return <>{children}</>;
};

export default ScrollToTop;
